import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import connectionTemplate from "../templates/connectionInfoTemplate.xlsx";
import { normalizeIntegrationKey } from "./integrations";
import { fetchStoreCredentialsAPI } from "./api/stores";

const setCell = (sheet, cell, value = "") => {
  sheet.getCell(cell).value = value ?? "";
};

const USER_ROWS = {
  Jahez: 3,
  HungerStation: 4,
  Keeta: 5,
  ToYou: 6,
  Marsool: 7,
  Ninja: 8,
  Lud: 9,
};

const APP_ORDER = [
  "Jahez",
  "HungerStation",
  "Keeta",
  "ToYou",
  "Marsool",
  "Ninja",
  "Lynk",
];

// Row names used by the Excel template, per canonical integration key.
const TEMPLATE_ROW_NAMES = {
  jahez: "Jahez",
  hungerstation: "HungerStation",
  keeta: "Keeta",
  toyou: "ToYou",
  marsool: "Marsool",
  ninja: "Ninja",
  LUD: "Lud",
};

const normalizeAppName = (name = "") => {
  const key = normalizeIntegrationKey(name);
  if (key && TEMPLATE_ROW_NAMES[key]) return TEMPLATE_ROW_NAMES[key];

  const cleanName = String(name).trim().toLowerCase();
  if (cleanName === "lynk" || cleanName === "link") return "Lynk";
  return String(name).trim();
};

const copyRowStyle = (sheet, fromRowNumber, toRowNumber) => {
  const fromRow = sheet.getRow(fromRowNumber);
  const toRow = sheet.getRow(toRowNumber);

  toRow.height = fromRow.height;

  fromRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
    const newCell = toRow.getCell(colNumber);
    newCell.style = JSON.parse(JSON.stringify(cell.style || {}));
    newCell.numFmt = cell.numFmt;
    newCell.alignment = cell.alignment;
    newCell.border = cell.border;
    newCell.fill = cell.fill;
    newCell.font = cell.font;
  });
};

const getUsers = (item) => {
  return Array.isArray(item?.userInfo) ? item.userInfo : [];
};

const getUser = (users, appName) => {
  return users.find((user) => normalizeAppName(user?.app) === appName) || {};
};

const getBranchApp = (branch, appName) => {
  const apps = Array.isArray(branch?.apps) ? branch.apps : [];

  return apps.find((app) => normalizeAppName(app?.app) === appName) || {};
};

const createBranchRowsIfNeeded = (sheet, branchesCount) => {
  const templateBranchStart = 10;
  const templateBranchEnd = 16;
  const templateRowsCount = templateBranchEnd - templateBranchStart + 1;

  if (branchesCount <= templateRowsCount) return 0;

  const extraRows = branchesCount - templateRowsCount;
  const insertAt = templateBranchEnd + 1;

  sheet.insertRows(insertAt, Array.from({ length: extraRows }, () => []));

  for (let i = 0; i < extraRows; i++) {
    copyRowStyle(sheet, templateBranchEnd, insertAt + i);
  }

  return extraRows;
};

const createAppBlock = (sheet, startRow, sourceStartRow) => {
  sheet.insertRows(startRow, Array.from({ length: APP_ORDER.length }, () => []));

  APP_ORDER.forEach((_, index) => {
    copyRowStyle(sheet, sourceStartRow + index, startRow + index);
    setCell(
      sheet,
      `A${startRow + index}`,
      sheet.getCell(`A${sourceStartRow + index}`).value || ""
    );
  });
};

export const validateConnectionExport = (
 item
) => {

 const branches =
 item?.branches || [];

 const users =
 item?.userInfo || [];

 if (
   !item?.businessName
 ) {

   return {
     valid:false,
     message:
     "اسم المطعم مفقود"
   };
 }

 if (
   !branches.length
 ) {

   return {
     valid:false,
     message:
     "لا يوجد فروع"
   };
 }

 if (
   !users.length
 ) {

   return {
     valid:false,
     message:
     "بيانات التطبيقات ناقصة"
   };
 }

 return {
   valid:true
 };

};

export const exportConnectionInfo = async (item) => {
  // Passwords are not part of the restaurant data: read them from the dedicated endpoint.
  // Where the caller may not read them the column is simply left empty.
  const credentials = await fetchStoreCredentialsAPI(localStorage.getItem("auth-token"), item?.id);
  const secrets = new Map((credentials?.userInfo || []).map((entry) => [String(entry._id), entry.pass]));

  const response = await fetch(connectionTemplate);
  const arrayBuffer = await response.arrayBuffer();

  const workbook = new ExcelJS.Workbook();
  await workbook.xlsx.load(arrayBuffer);

  const sheet = workbook.worksheets[0];

  const branches = item?.branches || [];
  const users = getUsers(item);
  const moreDetails = item?.moreDetails || {};

  // Public Information
  setCell(sheet, "B2", moreDetails.businessNameEn || item?.businessName || "");
  setCell(sheet, "B3", item?.businessName || "");
  setCell(sheet, "B4", item?.branchNumber || branches.length || "");

  // User Accounts
  Object.entries(USER_ROWS).forEach(([appName, row]) => {
    const user = getUser(users, appName);

    setCell(sheet, `E${row}`, user?.id || "");
    setCell(sheet, `F${row}`, user?.email || "");
    setCell(sheet, `G${row}`, secrets.get(String(user?._id)) || user?.pass || "");
  });

  // Branches table
  const extraBranchRows = createBranchRowsIfNeeded(sheet, branches.length);

  branches.forEach((branch, index) => {
    const row = 10 + index;

    setCell(sheet, `A${row}`, branch?.name || "");
    setCell(sheet, `B${row}`, branch?.phone || "");
    setCell(sheet, `C${row}`, branch?.location || "");
  });

  // Apps table starts after branch rows
  const firstAppBlockStart = 18 + extraBranchRows;

  branches.forEach((branch, branchIndex) => {
    const startRow = firstAppBlockStart + branchIndex * APP_ORDER.length;

    if (branchIndex > 0) {
      createAppBlock(sheet, startRow, firstAppBlockStart);
    }
APP_ORDER.forEach(
(appName, appIndex)=>{

 const row =
 startRow + appIndex;

 const app =
 getBranchApp(
 branch,
 appName
 );

 setCell(
 sheet,
 `B${row}`,
 branch?.name || ""
 );

 setCell(
 sheet,
 `C${row}`,
 app?.branchName ||
 app?.name ||
 ""
 );

 setCell(
 sheet,
 `D${row}`,
 app?.id || ""
 );

});
  });

  const buffer = await workbook.xlsx.writeBuffer();

  saveAs(
    new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    `${item?.businessName || "restaurant"}_connection_info.xlsx`
  );
};